export const cilChevronTop = ["24 24","<path d='M18.702 19.909l-6.702-6.702-6.702 6.702-4.555-4.555 11.257-11.262 0.257 0.259 0.276 0.273 4.027 4.027-0.003 0.003 6.7 6.7zM2.864 15.354l2.434 2.434 6.702-6.703 6.702 6.703 2.433-2.434-9.138-9.139-2.431 2.431-0.53 0.535z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-chevron-top.js
// module id = null
// module chunks = 